import {inject} from '@angular/core';
import {CanDeactivateFn} from '@angular/router';
import {UnsavedChangesService} from '../services/unsaved-changes.service';

/** Implemented by any routed component whose form can hold unsaved edits. */
export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = component => {
  if (!component.hasUnsavedChanges()) return true;

  return inject(UnsavedChangesService).confirmLeave();
};
